module.exports = __webpack_public_path__ + "media/src/ui/images/iconBinRed-3ac01e51f7c22578c41ba609a8015e63.svg";